import { FilterOrder, FilterOrders } from "#/organisms";
import { useCallback, useEffect, useState } from "react";

import { GenerateInvoices } from "@/components/pages";
import { OrderFilterParams } from "@/api/order/interface";
import { useApi } from "@/api";
import { useFilter } from "@/hooks";

const GenerateInvoicesView = () => {

  const { invoice, order } = useApi();
  const {
    filter,
    numberOfFilters,
    onOpenFilter,
    setShouldFilter,
    shouldFilter,
    showFilter,
    ...filterProps
  } = useFilter<FilterOrder>();
  const [loadingOrders, setLoadingOrders] = useState(false);
  
    useEffect(() => {
      invoice.loginIfNeeded();
    }, []);

  const getOrders = async (filterData?: OrderFilterParams) => {
    setLoadingOrders(true);
    await order.getOrderListForInvoice(filterData);
    setLoadingOrders(false);
  }

  useEffect(() => {
      getOrders();
  }, []);

  useEffect(() => {
    if (shouldFilter) {
      if (filter) {
        getOrders(filter && {
          customerCode: filter.customerCode,
          customerEmail: filter.customerEmail,
          customerName: filter.companyName,
          dateFrom: filter.dateFrom,
          dateTo: filter.dateTo,
          orderState: filter.state || null,
          propertyAddress: filter.location,
        });
      } else {
        getOrders({
        });
      }
      setShouldFilter(false);
    }
  }, [filter, shouldFilter]);

  const handleGenerate = useCallback(async (ids: string[]) => {
    await invoice.generateInvoiceByOrderIds(ids);
    filter ? await getOrders(filter) : await getOrders();
  }, [filter]);

  return (
    <>
      <GenerateInvoices
        loading={loadingOrders}
        numberOfFilters={numberOfFilters}
        orders={order.ordersForInvoice}
        onGenerate={handleGenerate}
        onOpenFilter={onOpenFilter}
      />
      {showFilter && <FilterOrders {...filterProps} filter={filter} numberOfFilters={numberOfFilters} showAdminFilter={true} />}
    </>
  );
}

export default GenerateInvoicesView;